<nav class="navbar navbar-expand-lg navbar-dark bg-primary">
  <a class="navbar-brand" routerLink="/">PQR</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01"
    aria-controls="navbarTogglerDemo01" [attr.aria-expanded]="!isCollapsed" aria-label="Toggle navigation"
    (click)="isCollapsed = !isCollapsed">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarTogglerDemo01" [ngbCollapse]="isCollapsed">
    <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
      <li class="nav-item">
        <a class="nav-link" routerLink="/radicar">Radicar PQR</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/consultar">Consultar PQR</a>
      </li>
    </ul>
  </div>
</nav>
<router-outlet></router-outlet>